import { Alert } from '@percent/lemonade'
import styles from './ErrorInfo.module.scss'
import { ErrorInfoProps } from './ErrorInfo.types'

export function ErrorInfo({ header, reasons, footer }: ErrorInfoProps) {
  return (
    <Alert variant="error" title={header} descriptionVariant="div" className={styles.wrapper}>
      {reasons ? (
        <ul>
          {reasons.map(reason => (
            <li key={reason}>{reason}</li>
          ))}
        </ul>
      ) : null}
      {footer ? <p className={styles.footer}>{footer}</p> : null}
    </Alert>
  )
}
